const { default: Swiper } = require('swiper');
import { Scrollbar } from 'swiper/modules';

const blogFilters = document.querySelector('.blog-filters');

if (blogFilters) {
    Swiper.use([Scrollbar]);
    const sliderElement = blogFilters.querySelector('.js-blog-filters-slider');
    const scrollbar = blogFilters.querySelector('.slider-scrollbar');
    let swiper = null;

    function initSwiper() {
        if (window.innerWidth <= 991.98 && !swiper) {
            swiper = new Swiper(sliderElement, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                scrollbar: {
                    el: scrollbar,
                    dragClass: 'slider-scrollbar__drag',
                    draggable: true,
                },
            });
            const activeIndex = swiper.slides.findIndex(slide =>
                slide.classList.contains('-active')
            );
            swiper.slideTo(activeIndex);
        } else if (window.innerWidth > 991.98 && swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
}
